import {Storage} from "@/ts/utils/storage";

export const sessionStore: Storage = new Storage();
